// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/accordion/accordion.js#1 $
'use strict';
angular.module('tc.accordion', [])
/**
* @ngdoc directive
* @name tcApp.directive:tcAccordion
* @element ANY
* @description
* # tcAccordion
* The tc-accordion directive provides a collapsable content container, with a (transcluded) header (tc-accordion-header)
*/
.directive('tcAccordion', function(GlobalService, ElementStateService,tcConstants) {
	return {
		restrict: 'E',
		transclude: true,
		scope: {
			elementId: '@id',
			title: '@tcAccordionTitle'
		},
		templateUrl: 'template/accordion/accordion.html',
		link: function(scope, element, attr) {
			
			var initialise = function() {		
				var state = ElementStateService.get(scope.elementId);
				if (angular.isUndefined(state)) {
					// Where element state has not been changed, get the initial value from the component option
					state = Object.prototype.hasOwnProperty.call(attr, 'tcAccordionStartCollapsed');
				}
				scope.collapsed = state;
				scope.dataItemsToAddress = {}; //items within this accordion, marked as required at one point 
				scope.hasItemToAddress = false;

				// Set if using Right-To-Left (RTL) direction to control chevron icon when it's collapsed (pointing left or right)
				scope.isRTL = false;
				if (angular.isDefined(GlobalService.logonData)) {
					scope.isRTL = (GlobalService.logonData.langDirection === tcConstants.LANG_DIRECTION.RIGHT_TO_LEFT);
				}

				// Setup initial chevron icon depending on reading direction
				if (!scope.collapsed) {
					scope.chevronIcon = 'system-chevron-down';	
				} else {
					if (scope.isRTL) {
						scope.chevronIcon = 'system-chevron-left';
					} else {
						scope.chevronIcon = 'system-chevron-right';
					}
				}	
			};
			
			initialise();

			scope.$watch('collapsed', function(collapsed) {
				// Now we need to ensure we can hide everything (except the header and aria-heading div)
				var children = element.children().children().children();
				angular.forEach(children, function(element) {
					if ((element.tagName.toLowerCase() !== 'tc-accordion-header') &&
						(element.id.indexOf('aria-heading') == -1)) {
						if (collapsed) {
							element.style.display = 'none';
						} else {
							element.style.display = '';
						}
					}
				});
				if (!collapsed) {
					GlobalService.triggerWindowResize();
					// Trigger any textareas to grow to fit their content
					scope.$broadcast('md-resize-textarea');
					scope.chevronIcon = 'system-chevron-down';
				} else {
					if (scope.isRTL) {
						scope.chevronIcon = 'system-chevron-left';
					} else {
						scope.chevronIcon = 'system-chevron-right';
					}
				}
			});
			
			scope.$on('Component:initialiseAccordions', function() {
				initialise();
			});
		}
	};
})
/**
* @ngdoc directive
* @name tcApp.directive:tcAccordionHeader
* @element ANY
* @description
* # tcAccordionHeader
* The tc-accordion-header directive provides a header bar with:
* * a title, set using the accordion-title attribute of the <tc-accordion> directive, and
* * and button area, populated using transclusion inside the <tc-accordion-header> directive
*/
.directive('tcAccordionHeader', function($timeout, GlobalService, ElementStateService) {
	return {
		restrict: 'E',
		transclude: true,
		templateUrl: 'template/accordion/accordionHeader.html',
		link: function(scope, element) {
			scope.toggleAccordion = function($event) {
				if ($event) {
					$event.preventDefault();
					$event.stopPropagation();
				}
				toggleAccordionState();

				// Scroll the content into view when expanding the accordion
				if (!scope.$parent.collapsed) {
					var headerElement = element[0];
					var contentElement = element.parent().parent()[0];
					var containerElement = GlobalService.getScrollableContainer()[0];
					if ((headerElement) && (contentElement) && (containerElement)) {
						// Execute after the content is visible
						$timeout(function() {
							GlobalService.scrollElementIntoView(headerElement, contentElement, containerElement);
						});
					}
				} else {
					resetHasItemToAddress();
				}
			};
			var toggleAccordionState = function() {
				scope.$parent.collapsed = !scope.$parent.collapsed;
				ElementStateService.set(scope.$parent.elementId, scope.$parent.collapsed);
			};
			
			var resetHasItemToAddress = function() {
				var hasRequired = false;
				angular.forEach(scope.$parent.dataItemsToAddress, function(formItem) {
					if (hasRequired) return;
					if (angular.isObject(formItem.$error)) {
						if ((formItem.$error.required) || (formItem.$error.invalid)) {
							hasRequired = true;
						}
					}
				});
				scope.$parent.hasItemToAddress = hasRequired;
			};
			
			/// re-checks the hasItemToAddress
			scope.$on('tcAccordionHeader:resetItem', function(event, accordionHeader, itemName) {
				if (!angular.equals(element, accordionHeader)) return;
				if (angular.isUndefined(scope.$parent.dataItemsToAddress[itemName])) return;
				resetHasItemToAddress();
			});
			
			/// expand an accordion only, does not scroll into view
			scope.$on('tcAccordionHeader:expandAccordion', function(event, accordionHeader, requiredFormItem) {
				if (!angular.equals(element, accordionHeader)) return;
				if (angular.isDefined(requiredFormItem)) {
					scope.$parent.dataItemsToAddress[requiredFormItem.$name] = requiredFormItem;
				}
				if (!scope.$parent.collapsed) return;
				toggleAccordionState();
			});
		}
	};
});
